import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, computed, inject, Signal, ViewEncapsulation } from '@angular/core';
import {
  AtAvatarComponent,
  AtOverlayComponent,
  AtSkeletonComponent,
  COMMON_DICTIONARY,
  CommonDictionary,
  ConfigurableAuthService,
} from '@anothertrip/anothertrip-ds';
import { take } from 'rxjs';

import { User, UserService } from '../../services/user/user.service';
import { UserProfileOverlayComponent } from '../user-profile-overlay/user-profile-overlay.component';

@Component({
  selector: 'app-user-overlay-select',
  imports: [AtOverlayComponent, AtSkeletonComponent, CdkOverlayOrigin, UserProfileOverlayComponent, AtAvatarComponent],
  templateUrl: './user-overlay-select.component.html',
  styleUrl: './user-overlay-select.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserOverlaySelectComponent {
  private readonly userService = inject(UserService);
  private readonly authService = inject(ConfigurableAuthService);
  protected readonly dictionary = inject<CommonDictionary>(COMMON_DICTIONARY).header.overlay;

  protected readonly user: Signal<User | null> = this.userService.currentUser;
  protected readonly isLoading = this.userService.isLoading;

  protected readonly username = computed<string | undefined>(() => this.user()?.name);

  protected readonly email = computed<string | undefined>(() => this.user()?.email);

  protected onLogout(): void {
    this.authService.logout(this.user()?.authProvider).pipe(take(1)).subscribe();
  }
}
